import { useMutation } from "@tanstack/react-query";
import { patchNok } from "../api/nok";

const usePatchNok = () => {
  const mutation = useMutation({ mutationFn: patchNok });
  return mutation;
};

export default usePatchNok;
